/** @format */

import { Component, OnInit } from '@angular/core';

import { Chain } from '@shared/data-access/interfaces';
import { ERROR_MESSAGES } from './site-down-message.constants';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'origin-site-down',
	templateUrl: './site-down.component.html',
	styleUrl: './site-down.component.scss',
	imports: [HmfButtonComponent]
})
export class SiteDownComponent implements OnInit {
	errorMessageConfig: (typeof ERROR_MESSAGES)['dsg'];

	constructor(private chain: Chain) {}

	ngOnInit() {
		const chainValue = this.chain.chainMarketingIdentifierAbbr;
		this.errorMessageConfig = ERROR_MESSAGES[chainValue] || ERROR_MESSAGES['dsg']; // default to dickssportinggoods if chainValue is not matched
	}
}
